import * as types from "../../../../constants/actionTypes";

const initialState = {
  copyJob: null,
  assignQuotePopupSearchText: "",
  assignQuotePopupEmployee: null,
  assignQuotePopupCustomer: null,
  assignQuotePopupSuccessText: "",
  userInfo: {
    phone: "",
    email: "",
    password: "",
    firstName: "",
    phoneNumber: "+1 ",
    postal: "",
    salesPersonEmail: (window.salesPerson ? window.salesPerson.email : ""),
    salesPersonFullName: (window.salesPerson ? window.salesPerson.name : ""),
    isNew: true,
    fabricatorId: document.kvConfig.userId || 61986,
    employeeId: "",
    lastName: "",
    phone2: "",
    address1: "",
    address2: "",
    state: "",
    preferredCommunicationMethod: "", // (I assume it will be constants - email or phone)
    howDidYouHearAboutUs: "", // (probably constants too, it is a select in the design)
    country: "", // can be received from getCustomerById response
    provence: "", // can be received from getCustomerById response
    shipping: {}, // address can be received from getCustomerById response
  },
  userInfoErrors: {},  // {"fullName": ["too short"]}, {"phoneNumber": ["this field is required"]}, etc.
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_SHOW_ASSIGN_QUOTE_POPUP:
    case types.SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT:
    case types.SET_ASSIGN_QUOTE_POPUP_EMPLOYEE:
    case types.SET_ASSIGN_QUOTE_POPUP_CUSTOMER:
    case types.SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_ASSIGN_QUOTE_POPUP_USER_INFO:
      return Object.assign({}, state, {
        userInfo: Object.assign({}, state.userInfo, action.payload.userInfo)
      });
    case types.SET_ASSIGN_QUOTE_POPUP_USER_INFO_ERRORS:
      return Object.assign({}, state, {
        userInfoErrors: Object.assign({}, state.userInfoErrors, action.payload.userInfoErrors)
      });
  }

  return state;

}
